import logoNew from "../assets/images/universityiatech/logo_new.png";
import logobroker from "../assets/images/universityiatech/logo.png";

export const baseUrl = "https://iatech-university-exxcustomer-1092359491361.us-central1.run.app/v1";
export const baseUrlFrontOffice = "https://university.iatech.pro"
export const baseUrlEnvironment = "https://university-ambassador.iatech.pro"

export const productName = "UNIVERSITY IA TECH IB";
export const googleSignInClientId = "448199233876-sr7d7agm2dr2hltkh85jbg50ndgjv23m.apps.googleusercontent.com";

export const vars = {
    productFaviconImgUrl: logoNew,
      title: "UNIVERSITY IA TECH IB",
      directPurchase: {
      version: "0.0.1",
      enabled: true,
    },
    freeChallenge: {
      version: "0.0.1",
      enabled: true,
      vars: {
        name: "Revolt Zero",
      }
    },
    poweredBy: {
      version: "0.0.1",
      enabled: true,
      vars: {
        url: "https://iatech.pro/",
      }
    },
};
export const brandName = "UNIVERSITY IA TECH IB";
export const logoUrlImg = logobroker

export const dashboard = {
  REPEATS: 'repeats',
}

export const sidenavData = [
    {
      name: "Dashboard",
      breadcrumb: "Dashboard",
      icon: "window",
      route: "/dashboard",
      key: "dashboard",
      ibTypesAllowed: [1, 2, 3, 4, 101],
    },
    {
      name: "Referidos",
      breadcrumb: "Referidos",
      icon: "person",
      route: "/dashboard/referred",
      key: "referred",
      ibTypesAllowed: [1, 2, 3, 4, 101],
    },
    {
      name: "Free Challenges",
      breadcrumb: "free",
      icon: "signal_cellular_alt",
      route: "/dashboard/referred-free-accs",
      key: "referred-free-accs",
      ibTypesAllowed: [1, 2, 3, 4],
    },
    {
      name: "Ventas",
      breadcrumb: "Ventas",
      icon: "signal_cellular_alt",
      route: "/dashboard/sales",
      key: "sales",
      ibTypesAllowed: [1, 2, 3, 4, 101],
    },
    {
      name: "Códigos",
      breadcrumb: "Códigos",
      icon: "confirmation_number",
      route: "/dashboard/codes",
      key: "codes",
      ibTypesAllowed: [1, 2, 3, 4],
    },
    {
      name: "Kit de recursos",
      breadcrumb: "Recursos",
      icon: "folder",
      route: "/dashboard/resources",
      key: "resources",
      ibTypesAllowed: [1, 2, 3, 4, 101],
    },
    {
      name: "Mis reportes",
      breadcrumb: "Reportes",
      icon: "equalizer",
      route: "/dashboard/associate-reports",
      key: "associate-reports",
      ibTypesAllowed: [100],
    },
    {
      name: "Mis reportes",
      breadcrumb: "Reportes",
      icon: "equalizer",
      route: "/dashboard/ipf-reports",
      key: "ipf-reports",
      ibTypesAllowed: [101],
    },
    {
      name: "Retiros",
      breadcrumb: "Wallet",
      icon: "wallet",
      route: "/dashboard/withdraws",
      key: "withdraws",
      ibTypesAllowed: [1,2,3,4, 100, 101],
    },
  ];